import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AtomFilterButtonComponent } from './atom-filter-button.component';

@NgModule({
    imports: [CommonModule, RouterModule],
    declarations: [AtomFilterButtonComponent],
    exports: [AtomFilterButtonComponent],
})
export class AtomFilterButtonModule {}
